import './Heading-b9360636.css';

var classes = {"ActionListHeader":"prc-ActionList-ActionListHeader-lEr8v"};

export { classes as default };
